import React, { ReactNode } from 'react'
import styles from './privacyPolicy.module.scss'
import Scrollspy from 'react-scrollspy'
import { Policies } from './PrivacyPolicy'

export interface PolicySection {
  title: string
  content: (props: object) => ReactNode
}

interface Props {
  sections: PolicySection[]
  intro?: ReactNode
  setSelectedTab?: React.Dispatch<React.SetStateAction<Policies>>
}

const Policy = ({ sections, intro, ...props }: Props) => {
  return (
    <div className={styles.main}>
      <div className={styles.sidePanel}>
        <Scrollspy
          offset={10}
          items={sections.map((_section, index) => `section-${index + 1}`)}
          currentClassName={styles.active}
        >
          {sections.map((section, index) => (
            <li key={index}>
              <a href={`#section-${index + 1}`}>{`${index + 1}. ${section.title}`}</a>
            </li>
          ))}
        </Scrollspy>
      </div>
      <div className={styles.sections}>
        {intro && <section>{intro}</section>}

        {sections.map((section, index) => (
          <section id={`section-${index + 1}`}>
            <h3>{`${index + 1}. ${section.title}`}</h3>
            {section.content(props)}
          </section>
        ))}
      </div>
    </div>
  )
}

export default Policy
